import styles from '../termsPage/TermsPage.module.css';
import React, { useEffect } from 'react';
import { Footer } from 'abu-common-components';
import TravellerPrivacy from '../../components/travellerPrivacy/TravellerPrivacy';
import { useNavigate } from 'react-router-dom';

const PrivacyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Privacy & Cookie Statement | Booking.com';
  }, []);

  return (
    <div className={styles.homeContainer} data-testid="privacyPageTestId">
      <TravellerPrivacy />
      <div className={styles.footerContent}>
        <Footer
          onTermsClick={() => navigate('/terms')}
          onPrivacyClick={() => navigate('/privacy')}
        />
      </div>
    </div>
  );
};

export default PrivacyPage;
